<template>
  <v-container fluid class="job_position-management mt-4 px-1">
    <v-row>
      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการตำแหน่ง</p><span class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + job_positions.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="job_positions"
                :search="search"
                sort-by="job_position_code">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.job_position_type="{ item }">
                <span>{{ displayText(item.job_position_type) }}</span>

              </template>

              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3" v-if="state=='editForm'">
                  <v-text-field
                      v-model="editForm.job_position_code"
                      :counter="5"
                      :rules = "editForm.textReqRules.concat(editForm.codeRules)"
                      label="รหัสตำแหน่ง"
                      required
                      disabled
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="3" v-else>
                  <v-text-field
                      v-model="editForm.job_position_code"
                      :counter="5"
                      :rules = "editForm.textReqRules.concat(editForm.codeRules)"
                      label="รหัสตำแหน่ง"
                      required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.job_position_s_th"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง ย่อ(TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      v-model="editForm.job_position_l_th"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง เต็ม(TH)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">
                  <v-text-field
                      v-model="editForm.job_position_s_en"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง ย่อ(EN)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      v-model="editForm.job_position_l_en"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง เต็ม(EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="3">
                  <v-select
                      v-model="editForm.job_position_type"
                      :rules="editForm.textReqRules"
                      :items="job_position_type_combo"
                      item-text="v_name"
                      item-value="v_value"
                      label="ประเภท"
                      required
                  ></v-select>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="7">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';

export default {
  name: 'Job_positionManagement',
  data() {
    return {
      state: 'index',
      snackbar: null,
      search: '',
      selected: [],
      headers: [
        {
          text: 'รหัสตำแหน่ง',
          align: 'start',
          value: 'job_position_code',
        },
        {text: 'ย่อ(TH)', value: 'job_position_s_th'},
        {text: 'ย่อ(EN)', value: 'job_position_s_en'},
        {text: 'เต็ม(TH)', value: 'job_position_l_th'},
        {text: 'เต็ม(EN)', value: 'job_position_l_en'},
        {text: 'ประเภท', value: 'job_position_type'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      job_position_type_combo: [
        {v_value: 'Default', v_name: 'ตำแหน่งงาน'},
        {v_value: 'Manage', v_name: 'ตำแหน่งบริหาร'},
        {v_value: 'Academic', v_name: 'ตำแหน่งทางวิชาการ'},
        {v_value: 'Other', v_name: 'อื่นๆ'},
      ],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        job_position_code: '',
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        job_position_s_th: '',
        job_position_s_en: '',
        job_position_l_th: '',
        job_position_l_en: '',
        job_position_type: null,
        active: 'N',
      },
    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('job_positions', ['job_positions', "isReceiving", "isDeleting", "idToDelete", "job_positionMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    job_positionMessage() {

      if (this.job_positionMessage !== '') {
        this.notification = this.job_positionMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getJob_positionsRequest();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('job_positions',
        [
          "getJob_positionsRequest",
          "deleteJob_positionRequest",
          "updateJob_positionRequest",
          "createJob_positionRequest"
        ]
    ),
    addItem() {
      this.editedIndex = -1 //index = -1 add

      this.editForm.job_position_code = null;
      this.editForm.job_position_s_th = null;
      this.editForm.job_position_s_en = null;
      this.editForm.job_position_l_th = null;
      this.editForm.job_position_l_en = null;
      this.editForm.job_position_type = null;
      this.editForm.active = 'Y';
      this.state = 'addForm';

    },
    editItem(item) {
      this.editedIndex = this.job_positions.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.job_position_code = item.job_position_code;
      this.editForm.job_position_s_th = item.job_position_s_th;
      this.editForm.job_position_s_en = item.job_position_s_en;
      this.editForm.job_position_l_th = item.job_position_l_th;
      this.editForm.job_position_l_en = item.job_position_l_en;
      this.editForm.job_position_type = item.job_position_type;
      this.editForm.active = item.active;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteJob_positionRequest({job_position_code: item.job_position_code})

    },
    close() {

      if (this.errorMessage == false || this.job_positionMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.job_positions[this.editedIndex], this.editForm)
            :
            this.updateJob_positionRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.job_positions.push(this.editForm)
            :
            this.createJob_positionRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    displayText(item) {
      return (this.job_position_type_combo.find(combobox => combobox.v_value === item)).v_name;

    }


  },
}
</script>

<style src="./JobPositManagement.scss" lang="scss"/>
